// extracted by mini-css-extract-plugin
module.exports = {"legalDisclaimer":"EnergyBalanceLegalDisclaimer_legalDisclaimer__K8Tiv","legalDisclaimerText":"EnergyBalanceLegalDisclaimer_legalDisclaimerText__42Hop"};